import { AppShell } from './components/app/AppShell';

/**
 * Main App component
 * Note: Providers are already wrapped in index.tsx via AppProviders
 * No need to re-wrap here
 */
export default function App() {
  return <AppShell />;
}
